import React from 'react';
import { Link } from 'react-router-dom';
import './Success.css';

const Cancel = () => {
  return (
    <div className="cancel-page">
      <div className="cancel-container">
        <div className="cancel-icon">
          <i className="fas fa-times-circle"></i>
        </div>
        <h1>Payment Cancelled</h1>
        <p>Your order has been cancelled and no payment has been processed.</p>
        <p>Your items are still in your cart if you wish to complete your purchase later.</p>
        <div className="cancel-actions">
          <Link to="/merch" className="return-btn">Return to Shop</Link>
        </div>
      </div>
    </div>
  );
};

export default Cancel;
